import { SurfaceType } from '@jms/model';
import type { SurfaceTypeDefinition } from '../../core/runtime/surfaces/surface.definition';
import { SURFACE_SCHEMA_SLOTS } from '../../core/runtime/surfaces/surface.schema.slots';

export const creatorSurface = {
  id: SurfaceType.Creator,
  saveStrategy: 'submit',
  defaultFieldMode: 'edit',
  viewStatePersistence: 'none',
  sectionLayout: { columns: 2, maxWidth: 1600, sectionBorder: false, columnDivider: true },
  slots: SURFACE_SCHEMA_SLOTS[SurfaceType.Creator],
} as const satisfies SurfaceTypeDefinition<SurfaceType.Creator>;
